import { SyncManager } from 'db';
import { useFormVehicleId } from './useFormVehicleId';

export const useRemoveImage = () => {
  const vehicleId = useFormVehicleId();

  const removeImage = async (imageId: number, isTyped: boolean, afterRemove?: () => void) => {
    if (!vehicleId) return;
    const syncManager = SyncManager.getInstance(vehicleId);
    if (isTyped) {
      await syncManager.queueEntityUpdate(imageId, 'image', [
        ['url', ''],
        ['url_thumb', '']
      ]);
    } else {
      await syncManager.queueRemovedImage(imageId);
    }
    if (afterRemove) {
      afterRemove();
    }
  };

  return removeImage;
};
